import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActionModuleEnum, ActionsService } from '@brafton/angular-framework-library';
import { StylesSmartTableComponent } from '@brafton/angular-styles-library';
import { Action, Organization, UserGroup, UserProfile } from '@brafton/common-framework-library';
import { BfAuthService } from '@brafton/skynet-angular-security-service';

@Component({
  selector: 'shared-users-listing',
  templateUrl: './users-listing.component.html',
  styleUrls: ['./users-listing.component.scss'],
  host: { class: 'users-listing' },
})
export class SharedUsersListingComponent implements OnInit {
  @Input() users!: UserProfile[];
  @Input() organization!: Organization;
  @Input() showLastLogin!: boolean;
  @Input() showRole!: boolean;
  @Input() showActions = true;
  @Input() showColumnHeaders = true;
  @Input() showGroups = false;
  actions!: Action[];

  @ViewChild('smartTable') smartTable!: StylesSmartTableComponent<any>;

  constructor(private auth: BfAuthService, private actionsService: ActionsService) { }

  ngOnInit(): void {
    this.getActionData();
  }

  buildMainColumns(): string[] {
    const columns = ['title']; //, 'email'

    if (this.showLastLogin === true) columns.push('lastLogin');
    columns.push('state');
    if (this.showRole === true) columns.push('role');
    if (this.showGroups === true) columns.push('groups');
    if (this.showActions === true) columns.push('actions');

    return columns;
  }

  editUserModal(user: any) {
    this.actionsService.changeActions(
      'EditUser',
      ActionModuleEnum.admin,
      this.organization as any,
      user,
      undefined,
      undefined,
      'project',
    );
  }

  removeStandardGroups(user: UserProfile): UserGroup[] {
    const groupsToIgnore = ['620adb37a9741a006595a260', '620adb32a9741a006595a25f', '620adb2ea9741a006595a25e', '620adb1da9741a006595a25d', '620adb4aa9741a006595a264', '620adb45a9741a006595a263', '620adb41a9741a006595a262', '620adb3ba9741a006595a261'];
    const groups = (user as any).groups?.filter((g: UserGroup) => groupsToIgnore.includes(g.id) === false);

    return groups;
  }

  getActionData() {
    const actionData = [
      {
        actionEnum: {
          hidden: false,
          displayName: 'Reset Password',
          id: 'ResetPassword',
        },
        isEnabled: true,
      },
      {
        actionEnum: {
          hidden: false,
          displayName: 'Edit User',
          id: 'EditUser',
        },
        isEnabled: true,
      },
      {
        actionEnum: {
          hidden: false,
          displayName: 'Delete User',
          id: 'DeleteUser',
        },
        isEnabled: true,
      },
      {
        actionEnum: {
          hidden: false,
          displayName: 'Edit Picture',
          id: 'EditPicture',
        },
        isEnabled: true,
      },
      {
        actionEnum: {
          hidden: false,
          displayName: 'Edit Permission',
          id: 'EditPermission',
        },
        isEnabled: true,
      },
    ];

    this.actions = actionData;
  }
}
